import { useCallback, useEffect, useState } from 'react';
import { fetchMailAccounts, type MailAccount } from './mailIntegrations.ts';
import { getErrorMessage } from '../utils/helperUtils.ts';

export const useMailAccounts = () => {
  const [accounts, setAccounts] = useState<MailAccount[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const reload = useCallback(async () => {
    setLoading(true);
    try {
      setAccounts(await fetchMailAccounts());
      setError(null);
    } catch (err) {
      setError(getErrorMessage(err));
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    void reload();
  }, [reload]);

  return { accounts, loading, error, reload };
};
